module.exports = __webpack_public_path__ + "img/guangzhou_xincheng (2).cfc5e1d4.png";